<app-panel [expandable]="false" [expanded]="true">
  <app-panel-header>
    <div class="flex flex-row justify-between items-center">
      <div class="flex flex-row items-center gap-[4px]">
        <span>{{ '+INSTALLATIONS.INSTALLATION.STICKY_PANEL.XOTA_CONSENT.TITLE' | translate }}</span>
        <mat-icon
          class="info-icon"
          [matTooltip]="'+INSTALLATIONS.INSTALLATION.STICKY_PANEL.XOTA_CONSENT.TOOLTIP' | translate"
          matTooltipPosition="above"
        >
          info
        </mat-icon>
      </div>

      <ng-container *ngIf="xotaAgreementLoading$ | async; else consentStatus">
        <mat-spinner diameter="20"></mat-spinner>
      </ng-container>

      <ng-template #consentStatus>
        <ng-container *ngIf="xotaAgreementStatus$ | async as status; else noConsent">
          <ng-container *ngIf="status !== XotaMode.None; else noConsent">
            <mat-icon class="consent-icon consent-icon--granted">check_circle</mat-icon>
          </ng-container>
        </ng-container>

        <ng-template #noConsent>
          <mat-icon class="consent-icon consent-icon--denied">cancel</mat-icon>
        </ng-template>
      </ng-template>
    </div>
  </app-panel-header>
</app-panel>
